import { useLingui } from "@lingui/react";
import FieldValuePair from "../../FieldValuePair.tsx";
import type { SpecProps } from "../types.ts";

export const ChassisType = ({ chassisType }: SpecProps<"chassis_type">) => {
  const { i18n } = useLingui();

  if (!chassisType) {
    return null;
  }

  const field = i18n.t({
    id: "itemPageLayout.keyInfo.chassisType",
    message: "Chassis type",
    comment: "Field for 'Chassis type' in ad specification",
  });

  return <FieldValuePair field={field} value={chassisType} />;
};
